import type { ModelName } from '@pigello/pigello-matrix';
import { parseAsRFCSafeString } from '@/hooks/use-table-filter/utils';
import type { Bookmark } from '@/lib/bookmark/types';

export function parseBookmarkQueryParams(bookmark: Bookmark) {
  const qp = bookmark.query_params;

  return {
    modelName: qp?.model_name as ModelName | undefined,
    search: qp?._search,
    overrideUrl: qp?.override_url,
    overrideUrlReplaceAll: qp?.override_url_replace_all === 'true',
    filters: qp?.filter ? parseAsRFCSafeString.parse(qp.filter) : undefined,
  };
}
